import ErrorPage from '@/views/error-page/404'
// import UserNew from '@/views/user-new'
import MyInvitation from '@/views/user-new/my-invitation'
import SharePullRegist from '@/views/user-new/share-pull-regist'
import Activitys from '@/views/activitys'
import Regist from '@/views/user-new/regist'
import Weixin from '@/views/weixin'
import SkuExchage from '../views/sku-exchange/index'

import SharePullRegistMember_20 from '@/views/integral_0803_20/share-pull-regist/index'

import Active_31 from '@/views/activity_31'
import Active_41 from '@/views/activity_41'
import InviteActivity from '@/views/activity_42'
import InviteOutsite from '@/views/activity_42/outsite';
import MyInvite from '@/views/activity_42/my-invite';
import Withdraw from '@/views/activity_42/withdraw';

import Active_31_ExplainPage from '@/views/activity_31/explain';

import Active_50 from '@/views/activity_50'
// import Active_80 from '@/views/activity_80'
import SharePullRegistMember_50 from '@/views/activity_50/share-pull-regist/index'
// import Sponsor50 from '@/views/activity_50/Sponsor/index'
// import Active_70 from '@/views/activity_70'
// import ActiveTurntable_70 from '@/views/activity_70/Turntable'
// import Active_94 from '@/views/activity_94'
import Address from '@/views/address'
import Active_110 from '@/views/activity_110'
// import Active_112 from '@/views/activity_112'
import Active_120 from '@/views/activity_120'
import Active_121 from '@/views/activity_121'
import Active_100 from '@/views/activity_100'
import Active_130 from '@/views/activity_130'
import Active_130Content from '@/views/activity_130/content'
import Active_130Create from '@/views/activity_130/create'
import SharePullRegistMember_100 from '@/views/activity_100/share-pull-regist/index'
import Active_135 from '@/views/activity_135'
import ActiveSettle_135 from '@/views/activity_135/settle'
import ActiveRule_135 from '@/views/activity_135/rules'
import Active_136 from '@/views/activity_136'
import ActiveSettle_136 from '@/views/activity_136/settle'
import ActiveRule_136 from '@/views/activity_136/rules'
import Active_138 from '@/views/activity_138'
import ActiveRule_138 from '@/views/activity_138/rules'
import ActiveRule_139 from '@/views/activity_139/rules'
import Active_139 from '@/views/activity_139'
import Active_145 from '@/views/activity_145'
import Active_146 from '@/views/activity_146'
import Active_147 from '@/views/activity_147'
import Active_147_code from '@/views/activity_147/code'
import Active_148 from '@/views/activity_148'
import Active_148_code from '@/views/activity_148/code'
import Active_149 from '@/views/activity_149'
import Active_150 from '@/views/activity_150'
import Active_151 from '@/views/activity_151'
import Active_151_code from '@/views/activity_151/code'
import Active_170 from '@/views/activity_170'
import Active_171 from '@/views/activity_171'
import Active_172 from '@/views/activity_172'
import Active_173_code from '@/views/activity_173/code'
import Active_174 from '@/views/activity_174'
import Active_174_code from '@/views/activity_174/code'
import Active_190 from '@/views/activity_190'
import ActiveRule_190 from '@/views/activity_190/rules'
import Active_205 from '@/views/activity_205'
import Active_208 from '@/views/activity_208'
import Active_209 from '@/views/activity_209'
import Active_210 from '@/views/activity_210'
import Active_210_code from '@/views/activity_210/share'
import Active_230 from '@/views/activity_230'
import Active_230_Raffle from '@/views/activity_230/raffle'
import Active_230_Award from '@/views/activity_230/award'
import Active_230_Rule from '@/views/activity_230/rule'

const routes = [
  {
    path: '*',
    component: ErrorPage,
    exact: true
  }
]

const asyncRoutes = [
  // {
  //   path: '/activity/user-new',
  //   component: UserNew,
  //   exact: true
  // },
  {
    path: '/activity/activitys',
    component: Activitys,
    name: 'Activitys',
  },
  {
    path: '/activity/address',
    component: Address,
    name: 'Address',
  },
  {
    path: '/activity/my-invitation/:id',
    component: MyInvitation,
    name: 'MyInvitation',
  },
  {
    path: '/activity/my-invitation',
    component: MyInvitation,
    name: 'MyInvitation',
  },
  {
    path: '/activity/share-pull-regist/:code',
    component: SharePullRegist,
    name: 'SharePullRegist',
  },

  {
    path: '/activity/regist/:type/:code',
    component: Regist,
    name: 'Regist'
  },
  {
    path: '/activity/regist/:code',
    component: Regist,
    name: 'Regist'
  },
  // {
  //   path: '/activity/value-investment',
  //   component: ValueInvestment,
  //   name: 'ValueInvestment'
  // },
  // {
  //   path: '/activity/members_0604/share-pull-regist/:code',
  //   component: SharePullRegistMember,
  //   name: 'SharePullRegist1`',
  // },
  // {
  //   path: '/activity/members_0604',
  //   component: members_0604,
  //   name: 'members_0604'
  // },
  // {
  //   path: '/activity/active_11/share-pull-regist/:code',
  //   component: SharePullRegistMember,
  //   name: 'active_11`',
  // },
  // {
  //   path: '/activity/active_11',
  //   component: investment_active11,
  //   name: 'active_11'
  // },
  {
    path: '/activity/sku-exchange',
    component: SkuExchage,
    name: 'sku-exchange'
  },

  {
    path: '/activity/active_20/share-pull-regist/:code',
    component: SharePullRegistMember_20,
    name: 'active_20'
  },
    {
    path: '/activity/active_20',
    component: InviteActivity,
    name: 'active_20'
  },
  // {
  //   path: '/activity/active_22/share-pull-regist/:code',
  //   component: SharePullRegistMember_22,
  //   name: 'active_22share'
  // },
  // {
  //   path: '/activity/active_22',
  //   // component: Active_22,
  //   component: Active_22,
  //   name: 'active_22'
  // },
  // {
  //   path: '/activity/active_30',
  //   component: Active_30,
  //   name: 'active_30'
  // },
  {
    path: '/activity/active_31',
    component: Active_31,
    name: 'active_31',
    exact: true
  },
  {
    path: '/activity/active_31/explain',
    component: Active_31_ExplainPage,
    name: 'active_31_explain',
    exact: true
  },
  // {
  //   path: '/activity/active_32',
  //   component: Active_32,
  //   name: 'active_32'
  // },
  // {
  //   path: '/activity/active_36',
  //   component: Active_36,
  //   name: 'active_36'
  // },
  // {
  //   path: '/activity/active_34',
  //   component: Active_34,
  //   name: 'active_34'
  // },
  // {
  //   path: '/activity/active_41',
  //   component: Active_41,
  //   name: 'active_41'
  // },
  // {
  //   path: '/activity/active_94',
  //   component: Active_94,
  //   name: 'active_94'
  // },
  {
    path: '/activity/active_42',
    component: InviteActivity,
    name: 'active_42',
    exact: true
  },
  {
    path: '/activity/active_42/outsite/:inviteCode',
    component: InviteOutsite,
    name: 'active_42-outsite',
    exact: true
  },
  {
    path: '/activity/active_42/my',
    component: MyInvite,
    name: 'active_42-my',
    exact: true
  },
  {
    path: '/activity/weixin',
    component: Weixin,
    name: 'Weixin-my',
    exact: true
  },
  
  {
    path: '/activity/active_42/withdraw',
    component: Withdraw,
    name: 'active_42-withdraw',
    exact: true
  },
  // {
  //   path: '/activity/active34/record',
  //   component: Active34Record,
  //   name: 'active_34_record'
  // },
  {
    path: '/activity/active_50/share-pull-regist/:code',
    component: SharePullRegistMember_50,
    name: 'active_22share'
  },

  {
    path: '/activity/active_50',
    component: Active_50,
    name: 'active_50',
  },
  {
    path: '/activity/active_100/share-pull-regist/:code',
    component: SharePullRegistMember_100,
    name: 'active_100share'
  },
 
  {
    path: '/activity/active_100',
    component: Active_100,
    name: 'active_100',
  },
  // {
  //   path: '/activity/active_80',
  //   // component: Active_22,
  //   component: Active_80,
  //   name: 'active_80',
  // },

  // {
  //   path: '/activity/active_70/turntable',
  //   component: ActiveTurntable_70,
  //   name: 'ActiveTurntable_70',
  // },
  // {
  //   path: '/activity/active_70',
  //   component: Active_70,
  //   name: 'active_70',
  // },
  // {
  //   path: '/activity/active_48',
  //   component: Active48,
  //   name: 'active_48',
  //   exact: true
  // },
  // {
  //   path: '/activity/active_48/outsite',
  //   component: Active48Outsite,
  //   name: 'active_48-outsite',
  //   exact: true
  // },
  {
    path: '/activity/active_110',
    component: Active_110,
    name: 'active_110'
  },
  // {
  //   path: '/activity/active_112',
  //   component: Active_112,
  //   name: 'active_112'
  // },
  {
    path: '/activity/active_120',
    component: Active_120,
    name: 'active_120'
  },
  {
    path: '/activity/active_121',
    component: Active_121,
    name: 'active_121'
  },
 
  {
    path: '/activity/active_130/create',
    component: Active_130Create,
    name: 'Active_130Create'
  },
  {
    path: '/activity/active_130/content',
    component: Active_130Content,
    name: 'Active_130Content'
  },
  {
    path: '/activity/active_130',
    component: Active_130,
    name: 'active_130'
  },
  {
    path: '/activity/active_135/settle',
    component: ActiveSettle_135,
    name: 'active_135settle'
  },
  {
    path: '/activity/active_135/rules',
    component: ActiveRule_135,
    name: 'ActiveRule_135'
  },
  {
    path: '/activity/active_135',
    component: Active_135,
    name: 'active_135'
  },
  {
    path: '/activity/active_136/settle',
    component: ActiveSettle_136,
    name: 'active_136settle'
  },
  {
    path: '/activity/active_136/rules',
    component: ActiveRule_136,
    name: 'ActiveRule_136'
  },
  {
    path: '/activity/active_136',
    component: Active_136,
    name: 'active_136'
  },
  {
    path: '/activity/active_138/rules',
    component: ActiveRule_138,
    name: 'ActiveRule_138'
  },
  {
    path: '/activity/active_138',
    component: Active_138,
    name: 'active_138'
  },
  {
    path: '/activity/active_139/rules',
    component: ActiveRule_139,
    name: 'active_139'
  },
  {
    path: '/activity/active_139',
    component: Active_139,
    name: 'active_139'
  },
  {
    path: '/activity/active_41',
    component: Active_41,
    name: 'active_41'
  },  {
    path: '/activity/active_145',
    component: Active_145,
    name: 'active_145'
  },
  {
    path: '/activity/active_146',
    component: Active_146,
    name: 'active_146'
  },
  {
    path: '/activity/active_147/code',
    component: Active_147_code,
    name: 'active_147_code'
  },
  {
    path: '/activity/active_147',
    component: Active_147,
    name: 'active_147'
  },
  {
    path: '/activity/active_148/code',
    component: Active_148_code,
    name: 'active_148_code'
  },
  {
    path: '/activity/active_148',
    component: Active_148,
    name: 'active_148'
  },
  {
    path: '/activity/active_149',
    component: Active_149,
    name: 'active_149'
  },
  {
    path: '/activity/active_150',
    component: Active_150,
    name: 'active_150'
  },
  {
    path: '/activity/active_151/code',
    component: Active_151_code,
    name: 'active_151_code'
  },
  {
    path: '/activity/active_151',
    component: Active_151,
    name: 'active_151'
  },
   {
    path: '/activity/active_174/code',
    component: Active_174_code,
    name: 'active_174_code'
  },
  {
    path: '/activity/active_174',
    component: Active_174,
    name: 'active_174'
  },
  {
    path: '/activity/active_170',
    component: Active_170,
    name: 'active_170'
  },
   {
    path: '/activity/active_171',
    component: Active_171,
    name: 'active_171'
  },
    {
    path: '/activity/active_172',
    component: Active_172,
    name: 'active_172'
  },
  {
    path: '/activity/active_173/code',
    component: Active_173_code,
    name: 'active_173_code'
  },
  {
    // path: '/activity/ActiveRule_135',
    path: '/activity/active_190/rules',
    component: ActiveRule_190,
    name: 'ActiveRule_190'
  },
  {
    path: '/activity/active_190',
    component: Active_190,
    name: 'active_190'
  },
  {
    path: '/activity/active_205',
    component: Active_205,
    name: 'active_205'
  },
   {
    path: '/activity/active_208',
    component: Active_208,
    name: 'active_208'
  },
  {
    path: '/activity/active_209',
    component: Active_209,
    name: 'active_209'
  },
  {
    path: '/activity/active_210/code',
    component: Active_210_code,
    name: 'active_210_code'
  },
  {
    path: '/activity/active_210',
    component: Active_210,
    name: 'active_210'
  },
  {
    path: '/activity/active_230/raffle',
    component: Active_230_Raffle,
    name: 'active_230_raffle'
  },
  {
    path: '/activity/active_230/award',
    component: Active_230_Award,
    name: 'active_230_award'
  },
  {
    path: '/activity/active_230/rule', // 创作激励
    component: Active_230_Rule,
    name: 'active_230_rule'
  },
  {
    path: '/activity/active_230', // 创作激励
    component: Active_230,
    name: 'active_230'
  },
]

export { routes, asyncRoutes }



// WEBPACK FOOTER //
// ./src/router/index.js